<template>
  <div @click="clickWrap" class="button-wrapper">
    <p class="button-text">{{value}}</p>
  </div>
</template>

<script>
export default {
  name: 'ModuleButtom',
  props: {
    value: {
      type: String,
      default: '模块按钮',
    },
    click: {
      type: Function,
      default: () => {
      },
    },
  },
  methods: {
    clickWrap() {
      this.click();
    },
  },
};
</script>

<style scoped lang="less">
  .button-wrapper {
    background-color: #ffffff;
    padding: 24px 0;
    margin: 0 0px;
    border-radius: 12px;
  }

  .button-text {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #008AFF;
    text-align: center;
    line-height: 30px;
  }
</style>
